// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetDistrictContactsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import DistrictContactDTO from '../models/DistrictContactDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
    districtId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
            districtId: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    districtId: 'districtId',
}

interface Result extends ResultDTO {
    districtContacts: DistrictContactDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            districtContacts: [],
        },
        initValues);
    },
    districtContacts: 'districtContacts',
}

export { Request, Result };